<template>
  <section class="page-trail light-panel">
    <div class="container page-trail__inner">
      <router-link v-if="backTo" class="page-trail__back" :to="backTo">
        {{ backLabel }}
      </router-link>
      <nav class="page-trail__crumbs" aria-label="Breadcrumb">
        <router-link
          v-for="(item, index) in items"
          :key="item.label + '-' + index"
          class="page-trail__crumb"
          :class="{ 'page-trail__crumb--current': index === items.length - 1 }"
          :to="item.to"
        >
          {{ item.label }}
        </router-link>
      </nav>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PageTrail',
  props: {
    items: {
      type: Array,
      required: true
    },
    backLabel: {
      type: String,
      default: 'Back'
    },
    backTo: {
      type: String,
      default: ''
    }
  }
}
</script>
